import { CompanyFormParams } from "../../../types/login";
import { FormValidationConfig } from "../Form.types";

export const createCompanyFormValidation =
  (): FormValidationConfig<CompanyFormParams> => ({
    company: {
      required: true,
      requiredMessage: "Company is required",
    },
  });
